import { Link } from "react-router-dom";
import { ArrowUpRight, RadioTower } from "lucide-react";

const links = [
  { href: "#manifest", label: "Manifest" },
  { href: "#erlebnis", label: "Erlebnis" },
  { href: "#registrierung", label: "QR-Ticket" },
];

export const Navbar = ({ availability }) => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-[#E5C378]/10 bg-[#09090D]/80 px-5 py-4 backdrop-blur-2xl sm:px-8">
    <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4">
      <a href="#top" data-testid="brand-home-link" className="flex items-center gap-3 text-[#F4F4F6]">
        <span className="grid h-10 w-10 place-items-center rounded-full border border-[#E5C378]/30 bg-[#E5C378]/10">
          <RadioTower className="h-4 w-4 text-[#E5C378]" />
        </span>
        <span className="font-syne text-sm font-extrabold tracking-[0.24em]">VYORA // PILOT</span>
      </a>
      <div className="hidden items-center gap-7 lg:flex">
        {links.map((link) => (
          <a key={link.href} data-testid={`nav-${link.label.toLowerCase().replace(" ", "-")}-link`} href={link.href} className="text-sm font-medium text-zinc-400 transition-colors duration-200 hover:text-[#E5C378]">
            {link.label}
          </a>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <div data-testid="scarcity-counter" className="hidden rounded-full border border-[#E5C378]/25 bg-[#E5C378]/10 px-4 py-2 font-mono text-xs uppercase tracking-[0.18em] text-[#E5C378] md:block">
          {availability ? `${availability.remaining}/${availability.phase_limit} frei • €${availability.current_price_eur}` : "Nur 50 • €10"}
        </div>
        <Link data-testid="organizer-panel-button" to="/admin" className="hidden rounded-full border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors duration-200 hover:border-[#E5C378]/50 hover:text-[#E5C378] sm:inline-flex">
          Veranstalter
        </Link>
        <a data-testid="nav-register-button" href="#registrierung" className="group inline-flex items-center gap-2 rounded-full bg-[#E5C378] px-5 py-2.5 text-sm font-bold text-[#09090D] shadow-[0_0_32px_rgba(229,195,120,0.28)] transition-transform duration-200 hover:-translate-y-0.5">
          Ticket sichern
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </nav>
  </header>
);
